/**
 * @generated SignedSource<<917cf7496fd6b667ec1caa39aa2ed397>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteEmailLayoutInput = {
  id: string;
};
export type DeleteEmailLayoutDialogMutation$variables = {
  input: DeleteEmailLayoutInput;
};
export type DeleteEmailLayoutDialogMutation$data = {
  readonly deleteEmailLayout: {
    readonly id: string;
  };
};
export type DeleteEmailLayoutDialogMutation = {
  response: DeleteEmailLayoutDialogMutation$data;
  variables: DeleteEmailLayoutDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "deleteEmailLayout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteEmailLayoutDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteEmailLayoutDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd19c37e73fe7b9043918bdaa6469817",
    "id": null,
    "metadata": {},
    "name": "DeleteEmailLayoutDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteEmailLayoutDialogMutation(\n  $input: DeleteEmailLayoutInput!\n) {\n  deleteEmailLayout(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a6bf8bfc500673b25c2eba2adce83f7";

export default node;
